/**
 * REQUIRED MARK
 *
 * Small red asterisk used inside form labels to signal a required field.
 * Pair with <RequiredLegend /> at the top of the form so users know what
 * the asterisk means.
 */

export function RequiredMark() {
  return (
    <span className="text-red-500 font-bold ml-0.5" aria-hidden="true">
      *
    </span>
  );
}

/**
 * Legend line explaining what the red asterisks mean. Drop near the top
 * of a form so users see it before scanning the fields.
 */
export function RequiredLegend() {
  return (
    <p className="text-xs text-light-secondary italic mb-3">
      <span className="text-red-500 font-bold">*</span> Required fields
    </p>
  );
}
